import React from 'react';
import Header from "../../header/Header";
import IconName from "../../../svgLogo/SvgLogo";
import {Link} from "react-router-dom";
import TimerCart from "../timer-cart/TimerCard";
import Card from "../../productsList/Card";
import Footer from "../../footer/Footer";

const SpecialOffer = () => {
    const products = [{
        "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
        "img": "./assets/sample-image/1420-w320h320.png",
        "price": "2,370,000 ",
        "color_range_1": "#192B3B",
        "color_range_2": "#F5F8FA",
        "color_range_3": "#1473E6",
        "link_product": "/singlePage",
        "type_card": "purple",
        "id": 1_0000,
        "discount": "2,760,008 ",
        "persian_name": "گوشی شیائومی می نوت ۹ پرو دوسیم کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ رم",
        "star": 4,
        "total_score": 128
    }, {
        "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
        "img": "./assets/sample-image/1420-w320h320.png",
        "color_range_1": "#192B3B",
        "color_range_2": "#F5F8FA",
        "color_range_3": "#1473E6",
        "discount": "2,760,008 ",
        "link_product": "/singlePage",
        "price": "2,370,000 ",
        "type_card": "purple",
        "id": 2_000000,
        "persian_name": "گوشی شیائومی می نوت ۹ پرو دوسیم کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ رم",
        "star": 4,
        "total_score": 128
    }, {
        "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
        "img": "./assets/sample-image/1420-w320h320.png",
        "color_range_1": "#192B3B",
        "color_range_2": "#F5F8FA",
        "color_range_3": "#1473E6",
        "discount": "2,760,008 ",
        "link_product": "/singlePage",
        "price": "2,370,000 ",
        "type_card": "purple",
        "id": 2_000000,
        "persian_name": "گوشی شیائومی می نوت ۹ پرو دوسیم کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ رم",
        "star": 4,
        "total_score": 128
    },
        {
            "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
            "img": "./assets/sample-image/1420-w320h320.png",
            "color_range_1": "#192B3B",
            "color_range_2": "#F5F8FA",
            "color_range_3": "#1473E6",
            "discount": "2,760,008 ",
            "link_product": "/singlePage",
            "price": "2,370,000 ",
            "type_card": "purple",
            "id": 2_000000,
            "persian_name": "گوشی شیائومی می نوت ۹ پرو دوسیم کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ رم",
            "star": 4,
            "total_score": 128
        },
        {
            "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
            "img": "./assets/sample-image/1420-w320h320.png",
            "color_range_1": "#192B3B",
            "color_range_2": "#F5F8FA",
            "color_range_3": "#1473E6",
            "discount": "2,760,008 ",
            "link_product": "/singlePage",
            "price": "2,370,000 ",
            "type_card": "purple",
            "id": 2_000000,
            "persian_name": "گوشی شیائومی می نوت ۹ پرو دوسیم کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ رم",
            "star": 4,
            "total_score": 128
        },
        {
            "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
            "img": "./assets/sample-image/1420-w320h320.png",
            "color_range_1": "#192B3B",
            "color_range_2": "#F5F8FA",
            "color_range_3": "#1473E6",
            "link_product": "/singlePage",
            "type_card": "out-of-stock",
            "id": 3_52,
            "persian_name": "گوشی شیائومی می نوت ۹ پرو دوسیم کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ رم",
            "star": 0,
            "total_score": 128
        },
        {
            "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
            "img": "./assets/sample-image/1420-w320h320.png",
            "color_range_1": "#192B3B",
            "color_range_2": "#F5F8FA",
            "color_range_3": "#1473E6",
            "discount": "2,760,008 ",
            "link_product": "/singlePage",
            "price": "2,370,000 ",
            "type_card": "purple",
            "id": 2_000000,
            "persian_name": "گوشی شیائومی می نوت ۹ پرو دوسیم کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ رم",
            "star": 4,
            "total_score": 128
        },
        {
            "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
            "img": "./assets/sample-image/1420-w320h320.png",
            "color_range_1": "#192B3B",
            "color_range_2": "#F5F8FA",
            "color_range_3": "#1473E6",
            "discount": "2,760,008 ",
            "link_product": "/singlePage",
            "price": "2,370,000 ",
            "type_card": "purple",
            "id": 2_000000,
            "persian_name": "گوشی شیائومی می نوت ۹ پرو دوسیم کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ رم",
            "star": 4,
            "total_score": 128
        },
        {
            "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
            "img": "./assets/sample-image/1420-w320h320.png",
            "color_range_1": "#192B3B",
            "color_range_2": "#F5F8FA",
            "color_range_3": "#1473E6",
            "discount": "2,760,008 ",
            "link_product": "/singlePage",
            "price": "2,370,000 ",
            "type_card": "purple",
            "id": 2_000000,
            "persian_name": "گوشی شیائومی می نوت ۹ پرو دوسیم کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ رم",
            "star": 4,
            "total_score": 128
        },
        {
            "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
            "img": "./assets/sample-image/1420-w320h320.png",
            "color_range_1": "#192B3B",
            "color_range_2": "#F5F8FA",
            "color_range_3": "#1473E6",
            "discount": "2,760,008 ",
            "link_product": "/singlePage",
            "price": "2,370,000 ",
            "type_card": "purple",
            "id": 2_000000,
            "persian_name": "گوشی شیائومی می نوت ۹ پرو دوسیم کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ رم",
            "star": 4,
            "total_score": 128
        },
        {
            "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
            "img": "./assets/sample-image/1420-w320h320.png",
            "color_range_1": "#192B3B",
            "color_range_2": "#F5F8FA",
            "color_range_3": "#1473E6",
            "discount": "2,760,008 ",
            "link_product": "/singlePage",
            "price": "2,370,000 ",
            "type_card": "purple",
            "id": 2_000000,
            "persian_name": "گوشی شیائومی می نوت ۹ پرو دوسیم کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ رم",
            "star": 4,
            "total_score": 128
        },
        {
            "name": "Samsung Galaxy Z Flip 256GB- 8GB RAM",
            "img": "./assets/sample-image/1420-w320h320.png",
            "color_range_1": "#192B3B",
            "color_range_2": "#F5F8FA",
            "color_range_3": "#1473E6",
            "discount": "2,760,008 ",
            "link_product": "/singlePage",
            "price": "2,370,000 ",
            "type_card": "purple",
            "id": 2_000000,
            "persian_name": "گوشی شیائومی می نوت ۹ پرو دوسیم کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ رم",
            "star": 4,
            "total_score": 128
        },]
    return (
        <div className="special-offer-product-page">
            <Header/>
            <div className="special-offer-content">
                <div className="header-box xpx-0 xpx-lg-6 xmb-5">
                    <nav className="nav-link-header d-flex justify-content-center">
                        <ul className="nav xp-2 xp-lg-3">
                            <li className="nav-item"><Link to="/specialOfferPage" className="nav-link active"><IconName
                                name="stars" className="icon"/> <span
                                className="text">پیشنهاد ویژه</span></Link></li>

                            <li className="nav-item"><Link to="/bundlesPage" className="nav-link"><IconName
                                name="library_add" className="icon"/> <span
                                className="text">باندل ها</span></Link></li>
                        </ul>
                    </nav>
                    <div className="offer-timer xpx-2 xpy-8 d-flex justify-content-center flex-column text-center">
                        <h2 className="title xmb-3">پایان هفته های شگفت انگیز</h2>
                        <div className="text-box d-flex justify-content-center">
                            <p className="text-offer">
                                طبق روال قبلی، پایان هفته های شگفت انگیز ما، از روز پنجشنبه شروع میشه و تا آخر روز جمعه
                                ادامه داره. پس قرارمون هر پنجشنبه و جمعه با کلی تخفیف داغ ;)
                            </p>
                        </div>
                        <div className="timer-box xmt-3 xmt-lg-6">
                            <TimerCart dataTime="april 30, 2022 18:37:25" theme="purple-timer"/>
                        </div>
                    </div>
                </div>
                <div className="container card-wrapper">
                    <div className="row">
                        {products && products.map((product) => (
                            <div className="col-6 col-lg-4 col-xl-4 col-xxl-3" key={product.id}>
                                <div className="box-cards xmt-6">
                                    <Card product={product}/>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="pagination-wrapper d-flex justify-content-center align-content-center">
                        <nav aria-label="Page navigation example">
                            <ul className="pagination persian-number xm-0">
                                <li className="page-item active"><a className="page-link" href="#">1</a></li>
                                <li className="page-item"><a className="page-link" href="#">2</a></li>
                                <li className="page-item"><a className="page-link" href="#">3</a></li>
                                <li className="page-item">
                                    <a className="page-link" href="#" aria-label="Next">
                                        <span aria-hidden="true"><IconName name="last_page" className="icon"/></span>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
};

export default SpecialOffer;
